import test from '.RegExp.prototype.test';
import bind from '.Function.prototype.bind?';

export var test_bind = bind
	? /*#__PURE__*/ bind.bind(test)                                                                       
	: function (            re        ) {
		return function (            string        ) {
			return test.call(re, string);
		};
	};

var IS_LIKE_SAFE_INTEGER = /*#__PURE__*/ test_bind(/^(?:0|[1-9]\d{0,15})$/);
var IS_LIKE_ARRAY_INDEX = /*#__PURE__*/ test_bind(/^(?:0|[1-4]\d{0,9}|[5-9]\d{0,8})$/);
export function isArrayIndex (key        )          {
	return IS_LIKE_ARRAY_INDEX(key) && key       <4294967295;
}
export function isIntegerIndex (key        )          {
	return IS_LIKE_SAFE_INTEGER(key) && key       <=9007199254740991;
}

import { RESERVED_WORD_ES3, RESERVED_WORD_ESM } from 'lib:reserved-word';
var IS_RESERVED_WORD_ES3 = /*#__PURE__*/ test_bind(RESERVED_WORD_ES3);
var IS_RESERVED_WORD_ESM = /*#__PURE__*/ test_bind(RESERVED_WORD_ESM);
export function isReservedWord (name        , noStrict          )          {
	return noStrict
		? IS_RESERVED_WORD_ES3(name)
		: IS_RESERVED_WORD_ESM(name);
}

import { IDENTIFIER_NAME_ES6, IDENTIFIER_NAME_ES3, IDENTIFIER_NAME_ES5 } from 'lib:unicode';
var IS_IDENTIFIER_NAME_ES6 = /*#__PURE__*/ test_bind(IDENTIFIER_NAME_ES6);
var IS_IDENTIFIER_NAME_ES3 = /*#__PURE__*/ test_bind(IDENTIFIER_NAME_ES3);
var IS_IDENTIFIER_NAME_ES5 = /*#__PURE__*/ test_bind(IDENTIFIER_NAME_ES5);
export function isIdentifierName (name        , ES         )          {
	if ( ES ) {
		if ( ES>=6 ) { return IS_IDENTIFIER_NAME_ES6(name); }
		if ( ES>=5 ) { return IS_IDENTIFIER_NAME_ES5(name); }
	}
	return IS_IDENTIFIER_NAME_ES3(name);
}
export function isIdentifier (id        , ES         , noStrict          )          {
	return isIdentifierName(id, ES) && !isReservedWord(id, noStrict);
}
export function isPropertyName (key        , ES         )          {
	return isIdentifierName(key, ES)
		? ES >=5 || !IS_RESERVED_WORD_ES3(key)
		: isIntegerIndex(key);
}

import { StringLiteral } from './Literal';
export function PropertyName (key        , ES         )         {
	return isPropertyName(key, ES) ? key : StringLiteral(key);// ['__proto__']
}
export function PropertyAccessor (key        , ES         )         {
	if ( isIdentifierName(key, ES) ) { if ( ES >=5 || !IS_RESERVED_WORD_ES3(key) ) { return '.' + key; } }
	else { if ( isIntegerIndex(key) ) { return '[' + key + ']'; } }
	return '[' + StringLiteral(key) + ']';
}
export function PropertyAccessors (keys                   , ES         )         {
	var propertyAccessors         = '';
	for ( var length = keys.length, index = 0; index<length; ++index ) {
		propertyAccessors += PropertyAccessor(keys[index] , ES);
	}
	return propertyAccessors;
}
